export default {"src":"/_next/static/media/mail-icon.7a99b023.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};